import { render, staticRenderFns } from "./project-tab-assign-staff.vue?vue&type=template&id=671b2c46"
import script from "./project-tab-assign-staff.vue?vue&type=script&lang=js"
export * from "./project-tab-assign-staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports